import React from 'react'
import axios from 'axios'

import Cabecalho from '../Cabecalho/Cabecalho'
import Processo from '../Form/Processo'
import Tv from '../Form/Tv'
import Inicio from '../Form/Inicio'
import PerfilSocial from '../Form/PerfilSocial'
import Identificacao from '../Form/Identificacao'
import Verificacao from '../Form/Verificacao'
import PublicidadeIrregular from '../Form/PublicidadeIrregular'
import Obs from '../Form/Obs'
import ProfissaoAi from '../Form/ProfissaoAi'
import AiFisio from '../Form/AiFisio'
import AiTo from '../Form/AiTo'
import Button from '../Form/Button'

export default class Social extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: {
                antiga: '', nova: '', repetida: '', user: localStorage.id
            }
        }
    }

    save(e) {
        e.preventDefault()
        const url = '/api/user/senha'
        const ficha = this.state.ficha
        axios.put(url, ficha)
            .then(res => {
                alert(res.data)
                window.location = `/`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
    }

    render() {
        return (
            <React.Fragment>
                <div className="container text-left">
                    <div className="form-group row">
                        <label className="col-3 col-md-2 mt-3">Senha Antiga:</label>
                        <div className="col-9 col-md-4 mb-3 mt-3">
                            <input type="password" className="form-control"
                                name="antiga" onChange={e => this.updateField(e)}/>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-3 col-md-2 mt-3">Nova Senha:</label>
                        <div className="col-9 col-md-4 mb-3 mt-3">
                            <input type="password" className="form-control"
                                name="nova" onChange={e => this.updateField(e)}/>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-3 col-md-2 mt-3">Repetir Nova Senha:</label>
                        <div className="col-9 col-md-4 mb-3 mt-3">
                            <input type="password" className="form-control"
                                name="repetida" onChange={e => this.updateField(e)}/>
                        </div>
                    </div>
                    <Button onClick={e => this.save(e)} />
                </div>
            </React.Fragment>
        )
    }
}